import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function Booklist() {
    const s3BaseUrl = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/pdf";
    const booklists = [
        {
            title: "Nursery Booklist",
            url: `${s3BaseUrl}/nur_booklist_smnsb.pdf`
        },
        {
            title: "Pre Nursery Booklist",
            url: `${s3BaseUrl}/pre_nur_smnsb.pdf`
        },
        {
            title: "Prep Booklist",
            url: `${s3BaseUrl}/prep_smnsb.pdf`
        }
    ];

    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Booklist</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Booklist</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container  them-container">
                    <div className="row justify-content-around g-4">
                        {booklists.map((item) => (
                            <div className="col-lg-3 col-md-6 col-sm-12" key={item.title}>
                                <div
                                    className="h-100 p-4 d-flex flex-column align-items-center"
                                    style={{
                                        borderRadius: "18px",
                                        background: "linear-gradient(145deg, #ffffff, #f9fbff)",
                                        border: "1px solid #d6e3f0",
                                        boxShadow: "0 12px 30px rgba(30, 92, 136, 0.14)",
                                        transition: "all 0.3s ease"
                                    }}
                                >
                                    <h4 style={{ fontSize: "22px", fontWeight: 700, color: "var(--main-color)", marginBottom: "8px", textAlign: "center", width: "100%" }}>
                                        {item.title}
                                    </h4>
                                    <a
                                        href={item.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{
                                            display: "inline-block",
                                            marginTop: "16px",
                                            padding: "10px 16px",
                                            borderRadius: "10px",
                                            background: "#FCC11A",
                                            color: "var(--main-color)",
                                            textDecoration: "none",
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            textAlign: "center",
                                            width: "100%"
                                        }}
                                    >
                                        View PDF
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default Booklist
